import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

class TopBlock extends PureComponent {
    render() {
        const { gender, ageGroup, postcode, sector, jobRating, unionMember, submitResults } = this.props;

        return (
            <div className="row no-gutters align-items-end">
                <div className="col-md-8">
                    <h2 className="formwrap-subtitle">ONE LAST THING!</h2>
                    <h1 className="formwrap-title">Tell us more about you.</h1>
                </div>
            </div>
        );
    }
}

export default TopBlock;



// WEBPACK FOOTER //
// ./src/Form/TopBlock.js